export default __webpack_public_path__ + "static/media/students-1.003bfc15.jpg";